import "./Header.css";

export class Header {
  constructor() {
    this.element = null;
  }

  render() {
    return `
      <header class="header">
        <h1 class="header__title">
          🔬 SMART PM
        </h1>
      </header>
    `;
  }

  mount(selector) {
    const container = document.querySelector(selector);
    if (!container) {
      throw new Error(`Header container ${selector} not found`);
    }

    container.innerHTML = this.render();
    this.element = container.querySelector(".header");
  }

  unmount() {
    if (this.element) {
      this.element.remove();
      this.element = null;
    }
  }
}
